

import { EnvGlobalsHandler } from "../../EnvGlobalsHandler";
import { IEnvironmentGlobals } from "../../IEnvironmentGlobals";

export class BasicCommand {
    /**
     * override the methode to specify the commandhandling
     * use super.executeCommand() to check errorcode 1 and 4
     */
    public executeCommand(error: number, params: any[]): boolean {
        return true;
    }

    protected get env(): IEnvironmentGlobals {
        return EnvGlobalsHandler.globals;
    }

    protected get cmdId(): string {
        return "";
    }
}

